import { render, staticRenderFns } from "./KeyWordSearch.vue?vue&type=template&id=1cff4b75&scoped=true&"
import script from "./KeyWordSearch.vue?vue&type=script&lang=js&"
export * from "./KeyWordSearch.vue?vue&type=script&lang=js&"
import style0 from "./KeyWordSearch.vue?vue&type=style&index=0&id=1cff4b75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cff4b75",
  null
  
)

export default component.exports